import './App.css';
import React from 'react';
import ChannelBox from "./ChannelBox";

function App() {
    return (
        <div className="Container">
            <h1>Choose a <span className="highlight">channel</span></h1>
            <div className="Grid">
                <ChannelBox name="BBC iPlayer" link="https://www.bbc.co.uk/iplayer" customClass="bbc-iplayer"/>
                <ChannelBox name="BBC Sounds" link="https://www.bbc.co.uk/sounds" customClass="bbc-sounds"/>
                <ChannelBox name="ITV Hub" link="https://www.itv.com/hub/itv" customClass="itvhub"/>
                <ChannelBox name="Channel 4" link="https://www.channel4.com/" customClass="all4"/>
                <ChannelBox name="My 5" link="https://www.channel5.com/" customClass="my5"/>
            </div>
        </div>
    );
}

export default App;
